<template lang="pug">
  v-row
    v-col(cols="12")
      .d-flex
        h1 {{ title }}
        v-spacer
        v-btn(
          :to="{ name: 'CourseCreate' }"
          color="success"
          class="px-3"
          rounded
        )
          v-icon mdi-plus
          span.ml-2.d-none.d-sm-block Добавить курс
      v-data-table(
        :headers="headers"
        :items="courses"
        :server-items-length="totalCourses"
        :page.sync="filters.page"
        :items-per-page="getPerPageFilter"
        :loading="loading"
        @update:items-per-page="setPerPageFilter"
      )
        template(v-slot:item.title="{ item }")
          router-link(
            class="font-weight-medium body-1"
            target="_blank"
            :to="{ name: 'CourseView', params: { id: item.id }}"
          ) {{ item.title }}
        template(v-slot:item.status="{ item }")
          span {{ getCourseStatusText(item.status) }}
        template(v-slot:item.type="{ item }")
          span {{ COURSE_TYPES[item.type] }}
        template(v-slot:item.rating="{ item }")
          v-rating(
            v-if="item.status.value !== COURSE_STATUSES.draft"
            :value="Math.round(item.rating/100*5)"
            :length="5"
            background-color="purple lighten-3"
            half-increments readonly dense
          )
        template(v-slot:item.actions="{ item }")
          v-btn(
            v-if="!item.rules.edit.value"
            color="secondary"
            text
            small
            rounded
            :to="{ name: 'CourseUnits', params: { id: item.id }}"
          )
            v-icon(class="mr-4") mdi-folder-edit-outline
            span Редактировать задания
          v-menu(
            v-else
            depressed
            nudge-bottom="10"
            transition="slide-y-transition"
            offset-y
            bottom
            left
          )
            template(v-slot:activator="{ on }")
              v-btn.mr-1.my-1(
                v-on="on" color="secondary" depressed small rounded @click.stop.prevent)
                v-icon(left small) mdi-cog
                | Изменить
            v-list(nav)
              v-list-item(
                v-if="item.rules.can_change_description.value"
                :to="{ name: 'CourseEdit', params: { id: item.id }}"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-file-document-edit-outline
                  | Редактировать описание
              v-list-item(
                v-if="item.rules.can_change_units.value"
                :to="{ name: 'CourseUnits', params: { id: item.id }}"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-folder-edit-outline
                  | Редактировать темы / задания
              //- v-list-item(
              //-   v-if=`item.rules.can_change_settings.value
              //-   && item.status.value !== COURSE_STATUSES.active`
              //-   :to="{ name: 'CourseSettings', params: { id: item.id }}"
              //- )
              //-   v-list-item-title
              //-     v-icon(class="mr-4") mdi-cogs
              //-     | Настройки курса / авторы, статус
              v-list-item(
                v-if="item.rules.can_view_enrollment.value"
                :to="{ name: 'CourseEnrollment', params: { id: item.id }}"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-folder-download-outline
                  | Наборы на курс
              v-list-item(
                v-if="item.rules.can_view_groups.value"
                :to="{ name: 'CourseGroupList', params: { courseId: item.id }}"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-account-group
                  | Группы курса
              v-list-item(
                v-if="item.rules.can_move_to_draft.value"
                @click="toDraftConfirmation = item.id"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-folder-move
                  | Снять с публикации
              v-list-item(
                v-if="item.rules.can_remove.value"
                @click="openDeleteDialog(item.id)"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-delete
                  | Удалить курс
              v-list-item(
                v-if="item.rules.owner.value"
                @click="openSendToExchangeDialog(item.id)"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-currency-usd
                  | Отправить на биржу
              v-list-item(
                v-if="item.rules.owner.value"
                @click="cloneCourse(item.id)"
              )
                v-list-item-title
                  v-icon(class="mr-4") mdi-content-copy
                  | Клонировать курс
          permissions-wrapper.d-inline-block(
            :roles="[$conf.ROLES.teacher]"
            exclude
            v-slot:default
          )
            v-btn.mr-1.my-1(
              v-if="item.edit && item.status === COURSE_STATUSES.draft && item.is_ready"
              title="Запустить в реализацию"
              color="secondary"
              depressed
              small rounded
              @click="startConfirmation = item.id"
            )
              v-icon(left small) mdi-rocket-launch
              | Запустить
            v-tooltip(
              v-if="item.edit && item.status === COURSE_STATUSES.draft && !item.is_ready"
              color="secondary"
              bottom
            )
              template(v-slot:activator="{ on, attrs }")
                v-icon(
                  right
                  small
                  v-on="on"
                ) mdi-help-circle-outline
                span.ml-2.vertical-align-middle Курс не готов
              div
                p.mb-2 Запуск курса возможен при соблюдении следующих условий:
                ul.mb-2
                  li Для курса создана хотя бы 1 группа
                  li Для группы назначен хотя бы 1 преподаватель

    confirm-dialog(
      :value="!!toDraftConfirmation"
      :loading="confirmationLoading"
      @confirm="setDraft"
      @input="toDraftConfirmation = null"
      v-slot:body
    )
      span Курс будет снят с публикации и отправлен в черновики. Продолжить?

    confirm-dialog(
      :value="!!startConfirmation"
      :loading="startConfirmationLoading"
      @confirm="startCourse"
      @input="startConfirmation = null"
      v-slot:body
    )
      span Курс будет запущен в реализацию. Продолжить?

    delete-dialog(
      :request="$api.courses.deleteCourse"
      :request-id="deleteId"
      v-model="showDeleteDialog"
      @delete="onDelete"
    )
      template(v-slot:body) Вы действительно хотите удалить данный курс?

    send-to-exchange-dialog(
      v-model="showSendToExchangeDialog"
      :course="courseToExchange"
    )

</template>

<script>
import { mapGetters } from 'vuex';
import { COURSE_STATUSES, COURSE_STATUSES_NAMES } from '@/utils/constants';
import SendToExchangeDialog from '@/modules/CourseManagement/components/SendToExchangeDialog.vue';

const COURSE_TYPES = {
  1: 'общеобразовательный',
  2: 'повышения квалификации',
};

export default {
  name: 'CourseList',
  components: {
    SendToExchangeDialog,
  },
  props: {
    title: { type: String, default: 'Все курсы' },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    COURSE_TYPES,
    headers: [
      { text: 'Название', value: 'title' },
      { text: 'Тип курса', value: 'type' },
      { text: 'Статус', value: 'status' },
      { text: 'Рейтинг', value: 'rating' },
      { text: 'Действия', value: 'actions' },
    ],
    totalCourses: null,
    filters: {
      page: 1,
      'per-page': -1,
    },
    courses: [],
    deleteId: null,
    showDeleteDialog: false,
    showSendToExchangeDialog: false,
    courseToExchange: {},
    toDraftConfirmation: null,
    confirmationLoading: false,
    startConfirmation: null,
    startConfirmationLoading: false,
    loading: false,
    COURSE_STATUSES,
    COURSE_STATUSES_NAMES,
    selectedCourse: {},
  }),
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
    getPerPageFilter() {
      if (this.filters['per-page'] === this.totalCourses) {
        return -1;
      }
      return this.filters['per-page'];
    },
  },
  watch: {
    filters: {
      handler() {
        this.getCourseList();
      },
      deep: true,
    },
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    setPerPageFilter(amount) {
      if (amount === -1) {
        this.filters['per-page'] = this.totalCourses;
      } else {
        this.filters['per-page'] = amount;
      }
    },
    getCourseList() {
      this.loading = true;
      const params = { ...this.params };
      params.expand = 'rules,edit,is_ready';

      this.$rHandler(
        this.$api.courses.getCourseList({ ...params, ...this.filters }),
        (r) => {
          this.courses = r.data.data;
          if (!this.totalCourses) {
            this.totalCourses = Number(r.headers['x-pagination-total-count']);
          }
          this.loading = false;
        },
      );
    },
    getCourseStatusText(status) {
      return this.COURSE_STATUSES_NAMES[status];
    },
    openDeleteDialog(courseId) {
      this.deleteId = courseId;
      this.showDeleteDialog = true;
    },
    onDelete(id) {
      this.courses = this.courses.filter((c) => c.id !== id);
    },
    openSendToExchangeDialog(courseId) {
      const selectedCourse = this.courses.find((course) => (
        course.id === courseId
      ));
      this.courseToExchange = selectedCourse;
      this.showSendToExchangeDialog = true;
    },
    async setDraft() {
      const DRAFT_STATUS = 2;
      this.confirmationLoading = true;
      await this.$rHandler(
        this.$api.courses.changeStatus(this.toDraftConfirmation, DRAFT_STATUS),
        (r) => {
          this.toDraftConfirmation = null;
          this.getCourseList();
          return r;
        },
      );
      this.confirmationLoading = false;
    },
    async startCourse() {
      this.startConfirmationLoading = true;
      await this.$rHandler(
        this.$api.courses.updateStatus(this.startConfirmation, { status: COURSE_STATUSES.active }),
        (r) => {
          this.startConfirmation = null;
          this.getCourseList();
          this.$toasted.success('Курс запущен в реализацию!', { duration: 3000 });
          return r;
        },
        () => {
          this.$toasted.error('Не удалось запустить курс в реализацию.', { duration: 3000 });
        },
      );
      this.startConfirmationLoading = false;
    },
    cloneCourse(id) {
      this.$rHandler(
        this.$api.courses.cloneCourse(id),
        ({ data }) => {
          this.$router.push({ name: 'CourseEdit', params: { id: data.data.id } });
          this.$toasted.success('Курс клонирован', { duration: 3000 });
        },
        () => {
          this.$toasted.error('Не удалось клонировать курс', { duration: 3000 });
        },
      );
    },
  },
};
</script>
